import styled from 'styled-components';
import { lightTheme as theme } from '../../../shared/theme';

export const MainContent = styled.div`
    max-width: 1120px;
    margin: 0 auto;
`;

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    background: ${theme.colors.background};
`;

export const PageShell = styled.section`
    width: 100%;
    background: ${theme.colors.paper};
    border-radius: 16px;
    border: 1px solid ${theme.colors.gray200};
    box-shadow: ${theme.colors.shadowSm};
    overflow: hidden;
`;

export const HeaderArea = styled.header`
    background: ${theme.colors.primary};
    color: ${theme.colors.headerText};
    padding: 20px 24px;
`;

export const HeaderStatusRow = styled.div`
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    .title {
        font-size: 22px;
        font-weight: 700;
        line-height: 1.2;
        color: ${theme.colors.headerText};
    }
`;

export const HeaderStatusBox = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    flex-wrap: nowrap;

    .label {
        color: ${theme.colors.headerTextMuted};
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        font-weight: 700;
        line-height: 1;
        white-space: nowrap;
    }

    @media (max-width: 768px) {
        width: 100%;
        justify-content: space-between;
    }
`;

export const ContentArea = styled.div`
    background: ${theme.colors.paper};
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SectionTitle = styled.h2`
    margin: 8px 0 0;
    padding-bottom: 8px;
    color: ${theme.colors.text};
    border-bottom: 1px solid ${theme.colors.gray200};
    font-size: clamp(1.04rem, 0.95rem + 0.42vw, 1.26rem);
    font-weight: 600;
`;

export const EmptyState = styled.p`
    margin: 0;
    text-align: center;
    color: ${theme.colors.textMuted};
    font-size: 0.95rem;
`;
